import { render } from "./vgpQuillEditor.vue?vue&type=template&id=638bf592"
import script from "./vgpQuillEditor.vue?vue&type=script&lang=js"
export * from "./vgpQuillEditor.vue?vue&type=script&lang=js"

import "./vgpQuillEditor.vue?vue&type=style&index=0&id=638bf592&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__